import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import WebFont from 'webfontloader';
import {BrowserRouter, Route, Routes, useHistory} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import es from 'date-fns/locale/es';
import {AuthProvider} from './contextos/AuthContext';
import {Contenedor,Fondo} from './elementos/ElementosIndex';
import InicioSesion from './componentes/InicioSesion';
import ListarTerminados from './componentes/ListarTerminados';
import ListarActivos from './componentes/ListarActivos';
import ListarActivos2 from './componentes/ListarActivos2';
import Descargas from './componentes/Descargas';
import Conductores from './componentes/Conductores';
import Clientes from './componentes/Clientes';
import Mapa from './componentes/Mapa';
import Mapa2 from './componentes/Mapa2';
import Pasajeros from './componentes/Pasajeros';
import CrearViaje from './componentes/CrearViaje';
import EditarViaje from './componentes/EditarViaje';
import CancelarViaje from './componentes/CancelarViaje';
import DetalleViaje from './componentes/DetalleViaje';
import DetalleViaje2 from './componentes/DetalleViaje2';
import TerminarViaje from './componentes/TerminarViaje';
import RutaProtegida from './componentes/RutaPrivada';
import favicon from './imagenes/logo.png';



WebFont.load({
  google: {
    families: ['Work Sans:400,500,700', 'sans-serif']
  }
});


const Index = () => {


  return (
      <>
      <Helmet>
          <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
      </Helmet>
      <AuthProvider>
        <BrowserRouter>
          <Contenedor>
                <Routes>
                  <Route path="/iniciar-sesion" element={<InicioSesion/>}/>
                  <Route path="/listar-terminados" element={
                      <RutaProtegida>
                         <ListarTerminados />
                      </RutaProtegida>
                  }/>
                  <Route path="/listar-activos" element={
                      <RutaProtegida>
                         <ListarActivos />
                      </RutaProtegida>
                  }/>
                  <Route path="/listar-activos2" element={
                      <RutaProtegida>
                         <ListarActivos2 />
                      </RutaProtegida>
                  }/>
                  <Route path="/descargas" element={
                      <RutaProtegida>
                         <Descargas />
                      </RutaProtegida>
                  }/>
                  <Route path="/conductores" element={
                       <RutaProtegida>
                       <Conductores />
                    </RutaProtegida>
                  }/>
                  <Route path="/clientes" element={
                       <RutaProtegida>
                       <Clientes />
                    </RutaProtegida>
                  }/>
                  <Route path="/mapa" element={
                       <RutaProtegida>
                       <Mapa/>
                    </RutaProtegida>
                  }/>
                    <Route path="/mapa2" element={
                       <RutaProtegida>
                       <Mapa2/>
                    </RutaProtegida>
                  }/>
                  <Route path="/pasajeros" element={
                       <RutaProtegida>
                       <Pasajeros />
                    </RutaProtegida>
                  }/>
                  <Route path="/crear-viaje" element={
                      <RutaProtegida>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                        <CrearViaje />
                        </LocalizationProvider>
                      </RutaProtegida>
                  } />
                  <Route path="/editar-viaje/:id" element={
                      <RutaProtegida>
                       <EditarViaje />
                      </RutaProtegida>
                  } />
                      <Route path="/cancelar-viaje/:id" element={
                      <RutaProtegida>
                       <CancelarViaje />
                      </RutaProtegida>
                  } />
                  <Route path="/detalle-viaje/:id" element={
                  <RutaProtegida>
                   <DetalleViaje />
                  </RutaProtegida>
              } />
              <Route path="/detalle-viaje2/:id" element={
                  <RutaProtegida>
                   <DetalleViaje2 />
                  </RutaProtegida>
              } />
                <Route path="/terminar-viaje/:id" element={
                  <RutaProtegida>
                   <TerminarViaje />
                  </RutaProtegida>
              } />
                  <Route path="/" element={
                      <RutaProtegida>
                       <App />
                      </RutaProtegida>
                  } />
                </Routes>
            </Contenedor>
          </BrowserRouter>
        </AuthProvider>
          <Fondo />
        </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Index />);